export default {
  login: {
    title: 'ログイン',
    username: 'ユーザー名',
    phone: '電話番号',
    phoneCode: 'コード',
    email: 'メール',
    password: 'パスワード',
    captcha: '認証コード',
    loading: '読み込み中...',
    rememberMe: 'ログイン状態を保持',
    forgotPassword: 'パスワードをお忘れですか？',
    loginButton: 'ログイン',
    contactUs: 'お問い合わせ？',
    noAccount: 'アカウントをお持ちでない方',
    registerNow: '新規登録',
    or: 'または',
    orSignInWith: 'または次でサインイン',
    methodUsername: 'ユーザー名',
    methodPhone: '電話',
    methodEmail: 'メール',
    usernameRequired: 'ユーザー名を入力してください',
    phoneRequired: '電話番号を入力してください',
    emailRequired: 'メールアドレスを入力してください',
    passwordRequired: 'パスワードを入力してください',
    captchaRequired: '認証コードを入力してください',
    resetPassword: 'パスワードリセット',
    resetStep1Hint: '電話番号またはメールアドレスを入力して認証コードを受け取ってください。',
    useEmailInstead: 'メールを使用',
    usePhoneInstead: '電話を使用',
    sendCode: 'コード送信',
    resetStep2Hint: '認証コードが送信されました',
    verificationCode: '認証コード',
    verificationCodeRequired: '認証コードを入力してください',
    resendIn: '再送信まで',
    resendCode: 'コード再送信',
    verify: '確認',
    resetStep3Hint: '新しいパスワードを設定してください。',
    newPassword: '新しいパスワード',
    confirmPassword: 'パスワード確認',
    passwordMinLength: 'パスワードは6文字以上である必要があります',
    confirmPasswordRequired: 'パスワードを確認してください',
    passwordMismatch: 'パスワードが一致しません',
    resetPasswordBtn: 'パスワードリセット',
    back: '戻る',
    // Format validation
    emailFormat: 'メール形式が無効です',
    // Toast messages
    loginSuccess: 'ログインに成功しました',
    loginFailed: 'ログインに失敗しました',
    signInWithGoogle: 'Google+でサインイン',
    codeSent: '認証コードを送信しました',
    sendCodeFailed: '認証コードの送信に失敗しました',
    invalidCode: '認証コードが無効です',
    resetSuccess: 'パスワードをリセットしました',
    resetFailed: 'パスワードのリセットに失敗しました'
  }
};
